(() => {
  'use strict';
  const locale = document.documentElement.lang;
  if (locale !== 'de' && locale !== 'en') return;
  const root = window.Shopify?.routes?.root;
  if (root !== `/${locale}/`) return;
  const repairBrowseLink = () => {
    document.querySelectorAll('section-store--cart-block').forEach((host) => {
      let config;
      try { config = JSON.parse(host.getAttribute('data-config') || '{}'); }
      catch { return; }
      if (config.short_id !== 's6Wg' || !host.shadowRoot) return;
      host.shadowRoot.querySelectorAll('div.cart-empty-actions-button a.cart-empty-continue[href="/collections/all"]').forEach((link) => {
        link.setAttribute('href', `${root}collections/all`);
      });
    });
  };
  const afterRender = () => window.requestAnimationFrame(repairBrowseLink);
  window.addEventListener('section-store:cart:opened', afterRender);
  window.addEventListener('section-store:cart:updated', afterRender);
  window.addEventListener('load', afterRender, { once: true });
  repairBrowseLink();
  afterRender();
})();
